
<template>
  <div id="publicmenutop">
    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <a class="navbar-brand"
            v-bind:href="home_frontend_url()"
        >{{ app_title() }}</a>
        <img v-bind:src="server_base_url() + '/img/topnav_logo_45px_hoch.png'" height="45" class="rounded">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link to="/public/about"  
                        tag="li" 
                        active-class="active"
                        class="nav-item" 
                        exact><a class="nav-link">Das Projekt</a></router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/public/mithelfen/whatsapp"  
                        tag="li" 
                        active-class="active"
                        class="nav-item" 
                        exact><a class="nav-link">Helfen mit Whatsapp</a></router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/public/mithelfen/telegram"  
                        tag="li" 
                        active-class="active"
                        class="nav-item" 
                        exact><a class="nav-link">Helfen mit Telegram</a></router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/public/statistik"  
                        tag="li" 
                        active-class="active"
                        class="nav-item" 
                        exact><a class="nav-link">Ruhmeshalle der Uploader</a></router-link>
                </li>
            </ul>
        </div>
    </nav>
  </div>
</template>

<script>
// Mixin fuer diese Komponente importieren
import commonvars from '../mixins/commonvars.js';

export default {
  name: 'mycover',
  mixins: [
    commonvars
  ],
  methods: {
    home_frontend_url() {
        return window.global_mycover.server_base_url + "/frontend";
    }
  }
};
</script>

<style scoped>
</style>

